
import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getCompanyNews } from './client/news-client';
import { mapPaginatorData } from '../utils/data-mappers';


export const useNewsQuery = (params) => {
    //console.log("params=====",params)
  const { data, error, isLoading } =  useQuery({
    queryKey: ["stock-news", params.tag],
    queryFn: async ({ pageParam = 1 }) => getCompanyNews.get( { tag:params.tag, ...params } ),
    
  });

  //console.log("News data====", data)

  return {
    news: data?.data,
    see_more_link:data?.see_more_link,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useHomeNewsQuery = () => {
    //console.log("params=====",params)
  const { data, error, isLoading } =  useQuery({
    queryKey: ["stock-home-news"],
    queryFn: async () => getCompanyNews.home(),
    
  });

  //console.log("News data====", data)

  return {
    news: data?.data,
    see_more_link:data?.see_more_link,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};
